import { useState, type ReactNode } from 'react'
import { View } from 'react-native'
import Animated, { useAnimatedReaction, useSharedValue } from 'react-native-reanimated'
import { runOnJS } from 'react-native-worklets'

import { WEB_TRANSLATE_IMAGE_Y } from '../../../hooks/useAnimatedHeader'
import { ListHeader } from '../ListHeader/ListHeader'
import type { TCommunityCompactHeaderProps } from './CommunityCompactHeader.types'

export const CommunityCompactHeader = ({
  community,
  header,
  offsetY,
  searchParams,
  subscription,
}: TCommunityCompactHeaderProps): ReactNode => {
  const [isVisible, setIsVisible] = useState(false)
  const fixedOffsetY = useSharedValue(WEB_TRANSLATE_IMAGE_Y * -1)

  useAnimatedReaction(
    () => offsetY.get(),
    (currentValue, previousValue) => {
      if (currentValue === previousValue) return
      runOnJS(setIsVisible)(currentValue <= -50)
    },
  )

  if (!isVisible) return null

  return (
    <View className="z-40 absolute left-0 right-0 top-0 h-24">
      {header}
      <Animated.View
        style={{
          height: 420,
          left: 0,
          right: 0,
          zIndex: 20,
          backgroundColor: 'white',
          boxShadow: '4px 0px 8px 0px rgba(0, 0, 0, 0.65)',
          transform: [{ translateY: fixedOffsetY.get() }],
        }}
      >
        <ListHeader
          community={community}
          offsetY={fixedOffsetY}
          searchParams={searchParams}
          subscription={subscription}
          animated
        />
      </Animated.View>
    </View>
  )
}
